var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "112.000000pt",
    height: "110.000000pt",
    viewBox: "0 0 112.000000 110.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,110.000000) scale(0.100000,-0.100000)",
    fill: "#FFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870 1078 c-47 -24 -88 -74 -97 -120 l-5 -28 -364 0 -363 0 -20 -26 c-20 -26 -21 -37 -21 -441 l0 -414 25 -24 24 -25 458 0 c481 1 506 3 555 47 11 10 29 36 39 58 17 37 19 73 18 440 0 420 -3 449 -46 497 -24 28 -91 58 -128 58 -17 0 -51 -10 -75 -22z m142 -45 c60 -30 63 -46 66 -405 2 -181 0 -328 -3 -328 -4 0 -21 10 -38 22 -47 34 -121 36 -179 4 l-48 -25 0 320 c0 349 3 368 56 406 48 34 87 36 146 6z m-242 -508 c0 -358 0 -365 20 -365 14 0 20 7 20 23 0 12 9 37 20 55 60 98 185 91 231 -12 33 -75 -6 -153 -87 -175 -25 -7 -193 -11 -471 -11 -379 0 -433 2 -447 16 -14 13 -16 65 -16 413 0 295 3 400 12 409 9 9 104 12 365 12 l353 0 0 -365z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 687 c-52 -25 -99 -64 -226 -189 -89 -87 -161 -164 -161 -173 0 -38 46 -4 190 141 128 128 197 184 226 184 3 0 -4 -17 -15 -37 -11 -21 -98 -116 -195 -212 l-175 -174 -36 31 c-41 37 -53 34 -104 -23 -31 -35 -35 -46 -31 -75 3 -24 52 -70 74 -70 14 0 101 80 258 238 203 203 240 245 262 296 14 32 26 64 26 71 0 26 -30 23 -93 -8z m-404 -475 c16 -17 15 -20 -16 -50 l-33 -32 -19 20 c-18 20 -18 21 10 50 34 35 37 36 58 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img_3.3708bcc4047a87d3b086ad917dbaf5ae.svg";
export { ForwardRef as ReactComponent };